import { Component, inject, OnInit, signal } from '@angular/core';
import { BusinessAccountService } from '../../../../services/business-account/business-account.service';
import { CurrentUserService } from '../../../../common/current-user/current-user.service';
import { take } from 'rxjs';
import { ImageService } from '../../../../services/image/image.service';
import { UserRolesEnum } from '../../../../common/general-types/users.dto';
import { BrandTeamAddUserComponent } from '../brand-team-add-user/brand-team-add-user.component';

@Component({
  selector: 'mb-brand-team',
  standalone: true,
  imports: [BrandTeamAddUserComponent],
  templateUrl: './brand-team.component.html',
  styleUrl: './brand-team.component.css'
})
export class BrandTeamComponent implements OnInit {


  allCompanyUsers = signal<any[] | undefined>(undefined);
  showAddUserDrawer = signal<boolean>(false);
  /** Resolved once so the add-user drawer is told which brand it is inviting into. */
  readonly focussedBrandId = signal<string | undefined>(undefined);

  /** Services */
  private businessAccountService = inject(BusinessAccountService);
  private currentUserService = inject(CurrentUserService);
  public imageService = inject(ImageService);
  /** Services - END */


  ngOnInit(): void {
    this.focussedBrandId.set(this.currentUserService.focussedBrand?.id);
    this.getAccountUsers();
  }

  getAccountUsers() {
    const businessAccountId = this.focussedBrandId();
    if (!businessAccountId) {
      // `focussedBrand` is undefined until a brand is selected; dereferencing it threw.
      this.allCompanyUsers.set([]);
      return;
    }
    this.businessAccountService.getAccountUsers(businessAccountId).pipe(take(1)).subscribe((users: any) => {
      this.allCompanyUsers.set(users);
    });
  }

  refreshUserList() {
    this.showAddUserDrawer.set(false);
    this.getAccountUsers();
  }

  getAccountStatus(user: any) {
    if (user.userAccount.inviteAccepted && user.userAccount.isActive) {
      return 'Active'
    } else if (!user.userAccount.inviteAccepted) {
      return 'Invite Sent'
    } else {
      return 'Inactive'
    }
  }

  accountStatusStyle(user: any) {
    switch (this.getAccountStatus(user)) {
      case 'Active':
        return "dark:bg-green-900/30 bg-green-50 text-green-700 ring-green-600 ring-opacity-20"
      case 'Invite Sent':
        return "dark:bg-orange-900/30 bg-orange-50 text-orange-700 ring-orange-600 ring-opacity-20"
      case 'Inactive':
        return "dark:bg-red-900/30 bg-red-50 text-red-700 ring-red-600 ring-opacity-20"
      default:
        return "dark:bg-gray-900/30 bg-gray-50 text-gray-700 ring-gray-600 ring-opacity-20"
    }
  }

  getRoleName(businessAccountRole: UserRolesEnum) {
    return UserRolesEnum[businessAccountRole]
  }
}
